export const RESET_WALLBOARD = 'RESET_WALLBOARD'
export const SET_WALLBOARD = 'SET_WALLBOARD'
export const SET_WALLBOARD_CARDS = 'SET_WALLBOARD_CARDS'
export const UPDATE_WALLBOARD_CARDS = 'UPDATE_WALLBOARD_CARDS'
